import { on } from 'delegated-events'
import { onDomReady } from 'utils/onDomReady'
const NAVIGATION_BUTTON = '.navigation-item-button--submenu'
const NAVIGATION_MENU = '.navigation-submenu'
const NAVIGATION_ITEM = '.navigation-item'
const NAVIGATION_OVERLAY = '.navigation-overlay'
const NAVIGATION_BACK_BTN = '.navigation-back-button'
const NAVIGATION_LIST_SELECTOR = '.navigation-list'

const ACTIVE_CLASSNAME = 'active'
const HEADER_TRANSPARENT_CLASSNAME = 'header--transparent'
const HEADER_FULLY_TRANSPARENT_CLASSNAME = 'header--fully-transparent'

const navigationOverlay = document.querySelector(NAVIGATION_OVERLAY)
const buttons = document.querySelectorAll(NAVIGATION_BUTTON)
const submenus = document.querySelectorAll(NAVIGATION_MENU)
const header = document.querySelector('.header')

const isNormalScreen = window.matchMedia('(min-width: 1024px)').matches

const addHeaderTransparentClass = () => {
  const transparentPaths = [
    '/',
    '/looker-studio-connector',
    '/power-bi-connector',
    '/google-sheets-connector'
  ]

  const fullyTransparentPaths = ['/ai-insights', '/mcp', '/ai-integrations']

  if (transparentPaths.includes(window.location.pathname)) {
    header.classList.add(HEADER_TRANSPARENT_CLASSNAME)
  }

  if (fullyTransparentPaths.includes(window.location.pathname)) {
    header.classList.add(HEADER_FULLY_TRANSPARENT_CLASSNAME)
  }
}

const removeHeaderTransparentClassOnScroll = () => {
  const isSubMenuActive =
    document.querySelector(`${NAVIGATION_OVERLAY}.${ACTIVE_CLASSNAME}`) !== null

  if (window.scrollY > 0) {
    header.classList.remove(HEADER_TRANSPARENT_CLASSNAME)
    header.classList.remove(HEADER_FULLY_TRANSPARENT_CLASSNAME)
  } else if (!isSubMenuActive) {
    addHeaderTransparentClass()
  }
}

const removeItemActive = () => {
  submenus.forEach(submenu => {
    submenu.style.maxHeight = ''
    submenu.classList.remove('open')
  })

  buttons.forEach(button => {
    button.closest(NAVIGATION_ITEM).classList.remove(ACTIVE_CLASSNAME)
  })

  const navList = document.querySelector(NAVIGATION_LIST_SELECTOR)
  if (navList) navList.classList.remove('submenu-visible')
}

const closeNavigation = () => {
  submenus.forEach(submenu => {
    submenu.style.transition = ''
  })

  navigationOverlay.classList.remove(ACTIVE_CLASSNAME)

  removeItemActive()

  if (window.scrollY === 0) {
    addHeaderTransparentClass()
  }
}

const handleButtonClick = event => {
  const parentItem = event.target.closest(NAVIGATION_ITEM)
  const submenuItem = event.target.nextElementSibling

  if (window.innerWidth < 1024) {
    event.preventDefault()
    if (submenuItem) {
      submenuItem.classList.add('open')
      submenuItem.scrollTop = 0

      const navList = document.querySelector(NAVIGATION_LIST_SELECTOR)
      if (navList) navList.classList.add('submenu-visible')
    }
    return
  }

  const isActive = parentItem.classList.contains(ACTIVE_CLASSNAME)
  const contentHeight = submenuItem.scrollHeight

  const hasActiveItem =
    Array.from(
      document.querySelectorAll(`${NAVIGATION_ITEM}.${ACTIVE_CLASSNAME}`)
    ).length > 0

  if (isNormalScreen && hasActiveItem) {
    submenus.forEach(submenu => {
      submenu.style.transition = isActive ? '' : 'none'
    })

    navigationOverlay.classList.remove(ACTIVE_CLASSNAME)

    if (window.scrollY === 0) {
      addHeaderTransparentClass()
    }
  }

  removeItemActive()

  if (!isActive) {
    parentItem.classList.add(ACTIVE_CLASSNAME)
    submenuItem.style.maxHeight = `${contentHeight}px`

    if (isNormalScreen) {
      navigationOverlay.classList.add(ACTIVE_CLASSNAME)
    }
    if (window.scrollY === 0) {
      header.classList.remove(HEADER_TRANSPARENT_CLASSNAME)
    }
  }
}

const handleBackClick = event => {
  event.stopPropagation()
  const submenu = event.target.closest(NAVIGATION_MENU)
  if (submenu) {
    submenu.classList.remove('open')
    const navList = document.querySelector(NAVIGATION_LIST_SELECTOR)
    if (navList) navList.classList.remove('submenu-visible')
  }
}

on('click', '.support-beacon', e => {
  e.preventDefault()

  closeNavigation()

  if (window.Beacon) {
    window.Beacon('open')
    window.Beacon('navigate', '/ask/message/')
  }
})

on('click', '.navigation-submenu-links__item--anchor', () => {
  closeNavigation()
})

on('click', NAVIGATION_BUTTON, handleButtonClick)
on('click', NAVIGATION_BACK_BTN, handleBackClick)

on(
  'click',
  `.navigation-submenu__action--video, ${NAVIGATION_OVERLAY}`,
  closeNavigation
)

onDomReady(() => {
  var path = window.location.pathname
  var menuLinks = Array.from(document.querySelectorAll('.navigation a'))

  menuLinks.forEach(link => {
    if (link.getAttribute('href') === path) {
      link.classList.add('active')
    }
  })

  addHeaderTransparentClass()

  let ticking = false
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        removeHeaderTransparentClassOnScroll()
        ticking = false
      })
      ticking = true
    }
  })
})
